import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { AuthService, CmsService, RoutingService, UrlPipe, TranslatePipe } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable, Subject, Subscription, of } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

import { KnBrCustomerContextService } from '../../store/kn-br-customer-context/kn-br-customer-context.service';
import { CustomerData } from './../../models/customer.model';
import { KnBrSidebarService } from './../../services/kn-br-sidebar.service';
import { OutletRefDirective, GlobalMessageComponent, PageLayoutComponent, PageSlotComponent, MediaComponent } from '@spartacus/storefront';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterLink } from '@angular/router';
import { AsyncPipe, NgClass } from '@angular/common';
import { MiniCartComponentService } from "@spartacus/cart/base/components/mini-cart";
import { RemoveLeadingZerosPipe } from '../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';
import { Auth0Service } from 'src/app/services/knbr-new-auth0.service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrCartContextService } from 'src/app/store/kn-br-cart-context/kn-br-cart-context.service';
import { Cart, MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { ActiveCartService } from '@spartacus/cart/base/core';

@Component({
  selector: 'kn-br-outlet',
  templateUrl: './kn-br-outlet.component.html',
  styleUrls: ['./kn-br-outlet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownItem,
    RouterLink,
    UrlPipe,
    TranslatePipe,
    OutletRefDirective,
    NgbDropdown,
    NgClass,
    GlobalMessageComponent,
    PageLayoutComponent,
    PageSlotComponent,
    MediaComponent,
    AsyncPipe,
    RemoveLeadingZerosPipe,
  ]
})
export class KnBrOutletComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  isHeaderHidden = false;
  customerContext$: Observable<CustomerData> = this.customerContextService.get$;
  isLoggedIn$: Observable<boolean> = this.authService.isUserLoggedIn();
  user$ = this.userService.get();
  subscription = new Subscription();
  private destory$ = new Subject<void>();
  pageTemplateName = '';
  isOpenMiniCartDropdown: boolean = false;
  quantity$: Observable<any> = this.miniCartComponentService.getQuantity();
  cartContext$: Observable<string> = this.knBrCartContextService.get$;

  hideCart = false;

  total$: Observable<string> = this.activeCartService.getActive().pipe(
    filter((cart) => !!cart.totalPrice),
    map((cart) => cart.totalPrice.formattedValue)
  );
  subTotal$: Observable<string> = this.activeCartService.getActive().pipe(
    filter((cart) => !!cart.subTotal),
    map((cart) => cart.subTotal.formattedValue)
  );

  readonly isLoginPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === 'KnBrLoginPageTemplate' ||
            page.template === 'knBrQuoteSellerApproverTemplate' ||
            page.template === 'SSOPageTemplate')
      )
    );
  readonly isUndefinedPage$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          !page || page.template === 'knBrQuoteSellerApproverTemplate' || page.template === 'ContentPage1Template'
      )
    );
  readonly hideBreadCrumb$ = this.cmsService
    .getCurrentPage()
    .pipe(
      map(
        (page) =>
          page &&
          (page.template === 'KnBrSearchResultsListPageTemplate' ||
            page.template === 'KnBrProductListPageTemplate' ||
            page.template === 'KnBrProductGridPageTemplate' ||
            page.template === 'KnBrSearchResultsGridPageTemplate' ||
            page.template === 'SalesLandingPage2Template' ||
            page.template === 'KnBrProductDetailsPageTemplate')
      )
    );
  readonly isNacPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => !page || page.template === 'NACPageTemplate'));
  readonly isStaticPage$ = this.cmsService
    .getCurrentPage()
    .pipe(map((page) => page && page.template === 'ContentPage1Template'));

  miniCart$: Observable<Cart>;
  cartId: string;
  cartEntries$: Observable<OrderEntry[]>;
  cartEntriesArray: OrderEntry[] = [];
  isRfq$: Observable<boolean>;

  constructor(
    private cmsService: CmsService,
    private customerContextService: KnBrCustomerContextService,
    private userService: UserAccountFacade,
    private sidebarService: KnBrSidebarService,
    private authService: AuthService,
    private routingService: RoutingService,
    private newAuth0Service: Auth0Service,
    private knBrCommonService: KnBrCommonService,
    private knBrCartContextService: KnBrCartContextService,
    protected miniCartComponentService: MiniCartComponentService,
    protected activeCartService: ActiveCartService,
    private multiCartFacade: MultiCartFacade,
    protected routing: RoutingService,
     private router: Router,
    private cdr: ChangeDetectorRef
  ) {

    this.knBrCartContextService.get$.subscribe((response) => {
      this.cartId = response ? response : null;
    });
    this.subscription.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        if (page) {
          this.pageTemplateName = page.template;
          if (page?.pageId === "purchasingAgentPage") {
            this.hideCart = true;
          }
          else{
            this.hideCart = false;
          }
        }
      })
    );

    this.subscription.add(
      this.cmsService.getCurrentPage().subscribe((page) => {
        if (page) {
          this.pageTemplateName = page.template;
        }
      })
    );
    // subscribe to mini cart open state from common service
    this.subscription.add(
      this.knBrCommonService.getMiniCartOpen().subscribe((open) => {
        this.isOpenMiniCartDropdown = !!open;
        this.cdr.detectChanges();
      })
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.isLoggedIn$.subscribe((res) => {
        if (res) {
          this.knBrCommonService.getRedirectionDetail().pipe(takeUntil(this.destory$)).subscribe({
            next: (redirect) => {
            },
            error: (error) => {
              console.error('Error occurred while fetching redirection detail:', error);
              this.logout();
            }
          });
        }
      })
    );

    this.subscription.add(
      this.cartContext$.subscribe((code) => {
        if (!code) {
          this.quantity$ = of(0);
          this.miniCart$ = of(null as any);
          this.cartEntries$ = of([]);
          this.cartEntriesArray = [];
          this.isRfq$ = of(false);
          this.isOpenMiniCartDropdown = false;
          this.cdr.detectChanges();
          return;
        }
        this.quantity$ = this.miniCartComponentService.getQuantity();
        this.multiCartFacade.reloadCart(code);
        this.miniCart$ = this.multiCartFacade.getCart(code).pipe(
          filter((cart) => !!cart),
          map((cart) => cart)
        );
        this.isRfq$ = this.multiCartFacade.getCart(code).pipe(
          filter((cart) => !!cart),
          map((cart) => String((cart as any).cartCategoryBrand || '').toLowerCase().includes('request a quote'))
        );
        this.cdr.detectChanges();
      })
    );

    this.cartEntries$ = this.activeCartService
      .getEntries()
      .pipe(filter((entries) => entries.length > 0));
    this.subscription.add(
      this.cartEntries$.subscribe((entries) => {
        this.cartEntriesArray = entries;
        this.cdr.detectChanges();
      })
    );
  }

  showCartPage() {
    const currentUrl = this.router.url;
    const excludeMiniCart = ["salesCart"];
    if (excludeMiniCart.some((route) => currentUrl.includes(route))) {
      return false;
    } else {
    this.routingService.goByUrl('salesCart');
    }
  }

  showMiniCart() {
    const currentUrl = this.router.url;
    const excludeMiniCart = ["salesCart", "salesCheckout"];
    if (excludeMiniCart.some((route) => currentUrl.includes(route))) {
      return false;
    } else {
    this.knBrCommonService.setMiniCartOpen(true);
    }
  }

  hideMiniCart() {
    this.knBrCommonService.setMiniCartOpen(false);
  }

  goToLocation(url) {
    this.knBrCommonService.setMiniCartOpen(false);
    this.knBrCommonService.setSpinner(true);
    this.router.navigateByUrl(url);
  }


  removeCustomerContext() {
    if (
      this.pageTemplateName === 'KnBrDraftOrderPageTemplate' ||
      this.pageTemplateName === 'KnBrQuotePageTemplate' ||
      this.pageTemplateName === 'KnBrOrderHistoryPageTemplate' ||
      this.pageTemplateName === 'KnBrReturnHistoryPageTemplate' ||
      this.pageTemplateName === 'KnBrFactSheetPageTemplate' ||
      this.pageTemplateName === 'CarlisleShippingListingPageTemplate' ||
      this.pageTemplateName === 'KnBrInvoiceListPageTemplate'
    ) {
      window.location.reload();
    } else if (this.pageTemplateName === 'KnBrDraftOrderDetailPageTemplate') {
      this.routingService.goByUrl('carts');
    } else if (this.pageTemplateName === 'KnBrQuoteDetailPageTemplate') {
      this.routingService.goByUrl('quotes');
    } else if (this.pageTemplateName === 'KnBrOrderDetailsPageTemplate') {
      this.routingService.goByUrl('customer-360/orders');
    } else if (this.pageTemplateName === 'KnBrReturnDetailsPageTemplate') {
      this.routingService.goByUrl('customer-360/returns');
    } else {
      this.routingService.goByUrl('');
    }

    this.customerContextService.delete();
  }
  changeMenuState() {
    this.sidebarService.toggleMenuState();
  }

  logout() {
    this.authService.coreLogout();
    this.newAuth0Service.logOutTheUser()
  }

  ngOnDestroy() {
    this.destory$.next();
    this.destory$.complete();
    this.subscription.unsubscribe();
  }
}
